import { effects } from 'redux-saga'

import handleViolations from 'internal-components/src/redux/sagas/effects/handleViolations'
import callWithHmac from 'internal-components/src/redux/sagas/effects/callWithHmac'
import { begin, end } from 'internal-components/src/redux/modules/loading'

import {
  addErrors,
  beginWork,
  clearErrors,
  setQualification,
  setQualificationResults,
  endWork,
} from '../../modules/signupEdit/actions'

export default function* addressLookup({ invocation }, { payload }) {
  try {
    yield effects.put.resolve(beginWork())
    yield effects.put.resolve(begin('qualify'))
    yield effects.put.resolve(clearErrors())

    const result = yield effects.call(
      callWithHmac,
      invocation.productQualify,
      payload.address,
      payload.searchedAddress,
    )

    yield effects.put.resolve(setQualification(result.id))
    yield effects.put.resolve(setQualificationResults(result.annotatedResults))

    return true
  } catch (e) {
    yield effects.call(handleViolations, e, addErrors)
  } finally {
    yield effects.put.resolve(end('qualify'))
    yield effects.put.resolve(endWork())
  }

  return false
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/qualify.js